<template>
  <el-form
    ref="form"
    :model="form"
    label-position="top"
    :disabled="$route.query.operateType === '查看'"
  >
    <div class="form_container">
      <!-- 认证法规 -->
      <el-form-item label="认证法规" prop="certificationRegulations">
        <el-input
          v-model="form.certificationRegulations"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <!-- 税收策略 -->
      <el-form-item label="税收策略" prop="taxStrategy">
        <el-input
          v-model="form.taxStrategy"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <!-- 补贴/罚款政策 -->
      <el-form-item label="补贴/罚款政策" prop="subsidiesFines">
        <el-input
          v-model="form.subsidiesFines"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <!-- 鼓励性/限制性汽车政策/充电桩建设 -->
      <el-form-item
        label="鼓励性/限制性汽车政策/充电桩建设"
        prop="incentiveRestrictive"
      >
        <el-input
          v-model="form.incentiveRestrictive"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { addOrUpdateBasePolicyApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      form: this.getForm()
    };
  },
  methods: {
    async init(data) {
      this.form = this.getForm(data || {});
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        id: data.id || "",
        certificationRegulations: data.certificationRegulations || "", // 认证法规
        taxStrategy: data.taxStrategy || "", // 税收策略
        subsidiesFines: data.subsidiesFines || "", // 补贴/罚款政策
        incentiveRestrictive: data.incentiveRestrictive || "" // 鼓励性/限制性汽车政策/充电桩建设
      };
    },
    // 保存
    async handleSave(params) {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        try {
          const submitData = JSON.parse(
            JSON.stringify({ ...params, ...this.form })
          );
          const res = await addOrUpdateBasePolicyApi(submitData);
          if (res.status == 0) {
            this.$DonMessage.success("操作成功！");
            this.form.id = res.data.id;
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form_container {
  margin-top: 34px;
  padding: 0 18px 0 50px;
  ::v-deep {
    .el-input {
      width: 200px;
    }
  }
  .input_number_box {
    width: 200px;
  }
  .number_input {
    ::v-deep {
      .el-input__inner {
        text-align: left;
        border-radius: 4px 0 0 4px;
      }
      .el-input {
        width: 100%;
      }
    }
  }
  .number_input_append {
    color: #666666;
    background: #efefef;
    border-radius: 0 4px 4px 0;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border: 1px solid #dcdfe6;
    border-left: none;
    box-sizing: border-box;
  }
}
</style>
